<template>
  <div class="heyxlsCollapse">
    <div class="between">
      <div class="cont flex_start">
        <div class="left flex_start">
          <span class="leftText">{{ leftText }}</span>
          <span class="all">不限</span>
        </div>

        <div class="right" v-if="isunfold">
          <div
            class="flex_start ify"
            v-for="(ifyitem, ifyindex) in tagify"
            :key="ifyindex"
          >
            <div class="title">{{ ifyitem.name }}:</div>
            <div class="zzzkk flex_start wrap">
              <span
                v-for="(tagitem, tagindex) in ifyitem.children"
                :key="tagindex"
                >{{ tagitem.name }}</span
              >
            </div>
          </div>
        </div>

        <div class="right flex_start" v-if="!isunfold">
          <span
            v-for="(item, index) in listsplic"
            :key="index"
            @click="condi(index)"
          >
            {{ item.name }}
          </span>
        </div>

      </div>
      <div class="svg" @click="isunfold=!isunfold"><svg-icon icon-class="jt_right"></svg-icon></div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    leftText: {
      type: String,
      default: "按专长",
    },
    tagify:{
      type:Array,
      default(){
        return []
      }
    }
  },
  data: () => ({
    status: -1,
    isunfold: false,
  }),
  computed: {
    listsplic() {
      let a = [];
      for (let item of this.tagify) {
          item.children[0]?a.push(item.children[0]):'';
          item.children[1]?a.push(item.children[1]):'';
      }
      return a;
    },
  },
  mounted() {},
  methods: {
    condi(index) {
      this.status = index;
    },
    tojump() {
      console.log("点击了跳转");
    },
  },
};
</script>

<style lang="scss" scoped>
.heyxlsCollapse {
  font-size: 16px;

  .cont {
    align-items: flex-start;
    span {
      border-radius: 5px;
      padding: 5px 18px;
      margin-right: 18px;
      margin-bottom: 10px;
    }
    .left {
      width: 170px;
      .leftText {
        margin-right: 0px;
      }
      .all {
        margin-right: 10px;
        &:hover {
          cursor: pointer;
           background: #0465ea;
           color: #fff ;
        }
      }
    }
    .right {
      width: 900px;
      span {
        &:hover {
          cursor: pointer;
           background: #0465ea;
           color: #fff ;
        }
      }
      .ify {
        align-items: flex-start;
        .title {
          width: 130px;
          font-size: 16px;
          color: #999999;
          padding: 5px 18px;
        }
        .zzzkk{
          width: 750px;
        }
      }
    }
  }
  .svg {
    flex: 1;
    align-self: self-start;
    text-align: center;
    position: relative;
    top: 7px;
    &:hover{
      color: #888;
    }
  }

 
}
</style>